import * as z from "zod/v4";
import { CustomerAgentThreadSchema } from "./get-customer-agent-threads";

export const messageCustomerAgent = {
  name: "messageCustomerAgent" as const,
  input: z.object({
    customerId: z.string(),
    message: z.string(),
    threadId: z
      .string()
      .optional()
      .describe("If left undefined, a new thread will be created."),
  }),
  output: z.object({ thread: CustomerAgentThreadSchema }),
};
